/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The device entered (or replaced) its sticky error state after a failed
 * catch: error LED held, companion-app modal shown. Mirrored on the device
 * in salmon/src/kodiak/events.py.
 * @export
 * @interface ErrorStateEnteredPayload
 */
export interface ErrorStateEnteredPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ErrorStateEnteredPayloadTypeEnum;
    /**
     * 
     */
    reason: string;
    /**
     * 
     */
    captureId?: string | null;
}


/**
 * @export
 */
export const ErrorStateEnteredPayloadTypeEnum = {
    ErrorStateEntered: 'error_state_entered',
} as const;
export type ErrorStateEnteredPayloadTypeEnum = typeof ErrorStateEnteredPayloadTypeEnum[keyof typeof ErrorStateEnteredPayloadTypeEnum];


/**
 * Check if a given object implements the ErrorStateEnteredPayload interface.
 */
export function instanceOfErrorStateEnteredPayload(value: object): value is ErrorStateEnteredPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'error_state_entered') return false;
    
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ErrorStateEnteredPayloadFromJSON(json: any): ErrorStateEnteredPayload {
    return ErrorStateEnteredPayloadFromJSONTyped(json, false);
}

export function ErrorStateEnteredPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorStateEnteredPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'reason': json['reason'],
        'captureId': json['capture_id'] === undefined ? undefined : json['capture_id'] === null ? null : json['capture_id'],
    };
}

export function ErrorStateEnteredPayloadToJSON(json: any): ErrorStateEnteredPayload {
    return ErrorStateEnteredPayloadToJSONTyped(json, false);
}

export function ErrorStateEnteredPayloadToJSONTyped(value?: ErrorStateEnteredPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'reason': value['reason'],
        'capture_id': value['captureId'],
    };
}

